import { DataSource, Layout, Panel, SaveButton, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSalesExpand extends Layout {
    buttonSave: SaveButton;
    panelLeft: Panel;
    panelNext: Panel;
    panelObjections: Panel;
    panelSave: Panel;
    sourceProspectAction: DataSource;
    textboxActionDate: Textbox;
    textboxDateDue: Textbox;
    textboxInfoPacket: Textbox;
    textboxNextActDate: Textbox;
    textboxNextActId: Textbox;
    textboxNextAction: Textbox;
    textboxObjection1Script: Textbox;
    textboxObjection2Script: Textbox;
    textboxObjectionId1: Textbox;
    textboxObjectionId2: Textbox;
    textboxRemarks: Textbox;
    textboxStatus: Textbox;
}
